exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".afterpay-messaging-container {\n  text-align: center;\n}\n.afterpay-messaging-container afterpay-placement {\n  --logo-badge-width: 80px;\n}\n@media only screen and (min-width: 0px) and (max-width: 559px) {\n.afterpay-messaging-container .afterpay-paragraph {\n    font-size: 10px !important;\n}\n.afterpay-messaging-container afterpay-placement {\n    --logo-badge-width: 65px;\n}\n}\n", ""]);

// exports
